import { EThemes } from '../models/themes';

export const themes: EThemes[] = [EThemes.Light, EThemes.Dark];
